import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: relative;
`;

export const WarningContainer = styled.div`
  display: flex;
  position: relative;
  font-size: 0.8em;
  color: #bd0707;
  padding: 10px;
`;

export const WarningHeader = styled.div`
  font-weight: bold;
  margin-right: 10px;
`;

export const WarningMessage = styled.div`
`;

export const AlertContainer = styled.div`
  display: flex;
  position: relative;
  font-size: 0.8em;
  color: #c9860b;
  padding: 10px;
`;

export const AlertHeader = styled.div`
  font-weight: bold;
  margin-right: 10px;
`;

export const AlertMessage = styled.div`
`;

export const CurrentVersionContainer = styled.div`
  display: flex;
  position: relative;
  font-size: 0.8em;
  color: #6c757d;
  padding: 10px;
`;

export const CurrentVersionName = styled.div`
  margin-right: 5px;
`;

export const CurrentVersionNumberName = styled.div`
  font-weight: bold;
`;